/**
 * Natura Karma — Checkout ürün sıralaması
 *
 * Shopify Checkout, aynı /cart/add.js isteğiyle eklenen ürünleri mevcut
 * Natura Karma kurulumunda ters sırada gösteriyor.
 *
 * Bu yama yalnızca _TF Grup içeren Natura Karma siparişlerini etkiler:
 *   İstek sırası: gönderim ücreti -> ek ürünler -> ana ürün
 *   Checkout sırası: ana ürün -> ek ürünler -> gönderim ücreti
 *
 * Normal Shopify ürün eklemelerine ve sepet görünümüne dokunmaz.
 */
(function () {
  'use strict';

  if (window.__TF_CHECKOUT_MAIN_FIRST_INSTALLED__) return;
  window.__TF_CHECKOUT_MAIN_FIRST_INSTALLED__ = true;

  var originalFetch = window.fetch.bind(window);

  function getUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartAddRequest(input) {
    return /\/cart\/add(?:\.js)?(?:\?|$)/i.test(getUrl(input));
  }

  function propertiesOf(item) {
    return item && item.properties && typeof item.properties === 'object'
      ? item.properties
      : {};
  }

  function isTfItem(item) {
    return Boolean(String(propertiesOf(item)['_TF Grup'] || '').trim());
  }

  function isMainItem(item) {
    return String(propertiesOf(item)['_TF Ana Ürün'] || '').toLowerCase() === 'true';
  }

  function isDeliveryFee(item) {
    return String(propertiesOf(item)['Hizmet'] || '')
      .toLocaleLowerCase('tr-TR')
      .trim() === 'gönderim bölgesi ücreti';
  }

  function sortTfItems(items) {
    /*
     * Shopify checkout mevcut mağazada çoklu ekleme sırasını ters gösteriyor.
     * Bu nedenle ana ürün istekte en sona konur.
     */
    return items
      .map(function (item, index) {
        var priority = 1; // ek ürün

        if (isDeliveryFee(item)) priority = 0;
        if (isMainItem(item)) priority = 2;

        return {
          item: item,
          index: index,
          priority: priority
        };
      })
      .sort(function (a, b) {
        if (a.priority !== b.priority) return a.priority - b.priority;
        return a.index - b.index;
      })
      .map(function (entry) {
        return entry.item;
      });
  }

  function transformBody(body) {
    if (typeof body !== 'string') return body;

    var payload;

    try {
      payload = JSON.parse(body);
    } catch (error) {
      return body;
    }

    if (!payload || !Array.isArray(payload.items)) return body;

    var tfItems = payload.items.filter(isTfItem);
    var hasMainItem = tfItems.some(isMainItem);

    if (tfItems.length < 2 || !hasMainItem) return body;

    /*
     * İstek normal ve TF ürünleri birlikte içeriyorsa yalnız TF grubunun
     * kendi iç sırasını değiştirir, diğer kalemlerin yerini korur.
     */
    var sortedTfItems = sortTfItems(tfItems);
    var tfIndex = 0;

    var transformedItems = payload.items.map(function (item) {
      if (!isTfItem(item)) return item;

      var sortedItem = sortedTfItems[tfIndex];
      tfIndex += 1;
      return sortedItem;
    });

    var transformedPayload = Object.assign({}, payload, {
      items: transformedItems
    });

    return JSON.stringify(transformedPayload);
  }

  window.fetch = function (input, init) {
    if (
      !isCartAddRequest(input) ||
      !init ||
      typeof init.body !== 'string'
    ) {
      return originalFetch(input, init);
    }

    var nextInit = Object.assign({}, init, {
      body: transformBody(init.body)
    });

    return originalFetch(input, nextInit);
  };
})();
